// api.js
import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//     'X-Requested-With': 'XMLHttpRequest'
//   },
//   withCredentials: true // 🔥 Required for httpOnly cookies to be sent
// });

// export default api;
const isProduction = process.env.NODE_ENV === 'production';

const api = axios.create({
  baseURL: isProduction
    ? 'https://fintrack.shop/api'
    : 'http://localhost:5000/api',
  timeout: 10000,
  withCredentials: true, // ✅ Always true — needed for dev (cross-origin)
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

export default api;